import { createContext, useContext } from 'react';

const StepContext = createContext({});

export const useStepContext = () => useContext(StepContext);
export const StepContextProvider = StepContext.Provider;
